import { render, staticRenderFns } from "./AgDatatable.vue?vue&type=template&id=3a3c83ba"
import script from "./AgDatatable.vue?vue&type=script&lang=js"
export * from "./AgDatatable.vue?vue&type=script&lang=js"
import style0 from "./AgDatatable.vue?vue&type=style&index=0&id=3a3c83ba&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports